import PageParameters from "./PageParameters";
import Shared from "@/common/shared";

export default class VoiceMailFilterModel {
  public startDate!: Date | null;
  public endDate!: Date | null;
  public pageParameters!: PageParameters;

  constructor() {
    this.endDate = null;
    this.startDate = null;
    this.pageParameters = new PageParameters();
  }
}
